/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { useState, useCallback } from 'preact/hooks';
import { InLineAlertInterface } from '../types';
import {
  CheckWithCircle as Success,
  Warning,
  WarningWithCircle as Error,
} from '@adobe-commerce/elsie/icons';

const iconsList = {
  success: <Success />,
  warning: <Warning />,
  error: <Error />,
};

export const useInLineAlert = () => {
  const [inLineAlertProps, setInLineAlertProps] =
    useState<InLineAlertInterface>({});

  const handleSetInLineAlertProps = useCallback(
    (notification: InLineAlertInterface | undefined) => {
      if (!notification || !notification.type) {
        setInLineAlertProps({});
        return;
      }

      const icon = iconsList[notification.type];

      setInLineAlertProps({
        ...notification,
        icon,
      });
    },
    []
  );

  return { inLineAlertProps, handleSetInLineAlertProps };
};
